const BASE_PATH = 'v1/Route';

export default function (instance) {
  return {
    // Route CRUD
    getRoutes(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getRoute(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    getRoutesByComponent(componentId, params = {}) {
      return instance.get(`${BASE_PATH}/by-component/${componentId}`, { params });
    },

    createRoute(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateRoute(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    deleteRoute(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    },

    setCurrentVersion(id) {
      return instance.post(`${BASE_PATH}/${id}/set-current`);
    },

    copyRoute(id, newName, targetComponentId) {
      const params = {};
      if (newName) params.newName = newName;
      if (targetComponentId) params.targetComponentId = targetComponentId;
      return instance.post(`${BASE_PATH}/${id}/copy`, null, { params });
    },

    // Components-list "group by Route" view
    getComponentUsage() {
      return instance.get(`${BASE_PATH}/component-usage`);
    },

    // Step Type lookup
    getStepTypes() {
      return instance.get(`${BASE_PATH}/step-types`);
    },

    // Route Step CRUD
    getSteps(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/steps`);
    },

    createStep(routeId, payload) {
      return instance.post(`${BASE_PATH}/${routeId}/steps`, payload);
    },

    updateStep(routeId, stepId, payload) {
      return instance.put(`${BASE_PATH}/${routeId}/steps/${stepId}`, payload);
    },

    deleteStep(routeId, stepId) {
      return instance.delete(`${BASE_PATH}/${routeId}/steps/${stepId}`);
    },

    updateStepPosition(routeId, stepId, payload) {
      return instance.patch(`${BASE_PATH}/${routeId}/steps/${stepId}/position`, payload);
    },

    // Route Graph (DAG)
    getGraph(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/graph`);
    },

    addDependency(routeId, payload) {
      return instance.post(`${BASE_PATH}/${routeId}/dependencies`, payload);
    },

    removeDependency(routeId, dependencyId) {
      return instance.delete(`${BASE_PATH}/${routeId}/dependencies/${dependencyId}`);
    },

    getOutputConsumption(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/output-consumption`);
    },

    getStepsWithoutRecipe(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/steps-without-recipe`);
    },

    getOrphanProductionOutputs(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/orphan-production-outputs`);
    },

    getMissingSemifinishedInputs(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/missing-semifinished-inputs`);
    },

    // Operator workflow
    getStepMaterials(routeId, stepId, warehouseId = null) {
      const params = warehouseId ? { warehouseId } : {};
      return instance.get(`${BASE_PATH}/${routeId}/steps/${stepId}/materials`, { params });
    },

    // Production Specification report
    getMaterialsByRoute(routeId) {
      return instance.get(`${BASE_PATH}/${routeId}/materials`);
    }
  };
}
